import React from 'react';

export const ProfileGray600Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.99996 8.14293C8.38091 8.14293 7.08567 6.88936 7.08567 5.35721C7.08567 3.82507 8.38091 2.5715 9.99996 2.5715C11.619 2.5715 12.9143 3.82507 12.9143 5.35721C12.9143 6.88936 11.619 8.14293 9.99996 8.14293ZM9.99996 10.0001C12.6666 10.0001 14.819 7.92007 14.819 5.35721C14.819 2.79436 12.6666 0.714355 9.99996 0.714355C7.33329 0.714355 5.18091 2.79436 5.18091 5.35721C5.18091 7.92007 7.33329 10.0001 9.99996 10.0001ZM16.6666 17.4286H3.33328V16.1936C3.33328 14.5686 5.53329 12.8879 9.99996 12.8879C14.4666 12.8879 16.6666 14.5686 16.6666 16.1936V17.4286ZM9.99996 11.0308C3.65709 11.0308 1.42852 14.1229 1.42852 16.1936V19.2858H18.5714V16.1936C18.5714 14.1229 16.3428 11.0308 9.99996 11.0308Z"
        fill="#333333"
      />
    </svg>
  );
};
